import ApiServices from "./ApiServices";
import gql from "graphql-tag";

export default class DamService extends ApiServices {
  constructor(credential = 'include') {
    super('/api/v1/dam/', credential);
  }

  async getAsset(id, fetchPolicy = "") {
    return await this.apolloClass.query({
      query: gql`
        query getAsset($id: Int!) {
          asset(id: $id){
            id,
            title,
            thumbnail,
            asset
          }
        }
      `,
      variables: {
        id
      },
      fetchPolicy
    });
  }

  async searchAsset(search) {
    return await this.apolloClass.query({
      query: gql`
        query getAssets($search: String!){
          search_assets_collections(search: $search) {
            assets{
              id, title, asset, thumbnail
            }
          }
        }
      `,
      variables: {
        search
      },
    });
  }

  async getGategory(category_id) {
    return await this.apolloClass.query({
      query:  gql`
      query getCategory($category_id: Int!){
        category(id:$category_id){
          banner,
          title
        }
      }
    `, variables: {
      category_id
    }
    });
  }
  
}





// WEBPACK FOOTER //
// ./src/services/DamService.js